export const themes = {
  light: {
    name: 'Light',
    colors: {
      // Primary colors
      '--color-primary-50': '254, 247, 237',
      '--color-primary-100': '253, 232, 209',
      '--color-primary-200': '251, 208, 163',
      '--color-primary-300': '247, 176, 106',
      '--color-primary-400': '242, 137, 47',
      '--color-primary-500': '237, 111, 14',
      '--color-primary-600': '222, 85, 9',
      '--color-primary-700': '184, 65, 10',
      '--color-primary-800': '147, 53, 15',
      '--color-primary-900': '120, 44, 13',
      
      // Background colors
      '--bg-primary': '254, 252, 248', // paper-white
      '--bg-secondary': '255, 255, 255',
      '--paper-white': '254, 252, 248',
      
      // Text colors
      '--text-primary': '31, 41, 55', // ink-black
      '--text-secondary': '107, 114, 128',
      '--ink-black': '31, 41, 55',
      
      // Border colors
      '--border-primary': '229, 231, 235',
    }
  },
  dark: {
    name: 'Dark',
    colors: {
      // Primary colors (same as light for consistency)
      '--color-primary-50': '254, 247, 237',
      '--color-primary-100': '253, 232, 209',
      '--color-primary-200': '251, 208, 163',
      '--color-primary-300': '247, 176, 106',
      '--color-primary-400': '242, 137, 47',
      '--color-primary-500': '237, 111, 14',
      '--color-primary-600': '222, 85, 9',
      '--color-primary-700': '184, 65, 10',
      '--color-primary-800': '147, 53, 15',
      '--color-primary-900': '120, 44, 13',
      
      // Background colors (dark theme)
      '--bg-primary': '17, 24, 39', // gray-900
      '--bg-secondary': '31, 41, 55', // gray-800
      '--paper-white': '31, 41, 55',
      
      // Text colors (dark theme)
      '--text-primary': '243, 244, 246', // gray-100
      '--text-secondary': '156, 163, 175', // gray-400
      '--ink-black': '243, 244, 246',
      
      // Border colors (dark theme)
      '--border-primary': '75, 85, 99', // gray-600
    }
  }
};

export const fonts = {
  'Inter': 'Inter, system-ui, sans-serif',
  'Crimson Text': 'Crimson Text, serif',
  'JetBrains Mono': 'JetBrains Mono, monospace',
  'Georgia': 'Georgia, serif',
  'Helvetica': 'Helvetica, Arial, sans-serif'
};
